import React from 'react';

const AntahkaranaLogo = ({ className = '', style = {}, size = 120 }) => {
  return (
    <svg
      className={`antahkarana-logo ${className}`}
      style={{ ...style, background: 'transparent' }}
      width={size}
      height={size}
      viewBox="-50 -50 100 100"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="cyberCyan" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#00f2fe" />
          <stop offset="100%" stopColor="#4facfe" />
        </linearGradient>
        <filter id="neonGlow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="3" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
        <path
          id="antahkarana-arm"
          d="M 0,0 L 0,-30 L 25.98,-15"
          stroke="url(#cyberCyan)"
          strokeWidth="6"
          strokeLinecap="round"
          strokeLinejoin="round"
          filter="url(#neonGlow)"
          fill="none"
          style={{ transition: 'all 0.3s ease' }}
        />
      </defs>

      <use href="#antahkarana-arm" />
      <use href="#antahkarana-arm" transform="rotate(120)" />
      <use href="#antahkarana-arm" transform="rotate(240)" />

    </svg>
  );
};

export default AntahkaranaLogo;
